<template>
    <div class="skill-score">
        <Navbar />
        <div class="mt-5 pt-5">
            <div class="container-fluid">
                <div class="row mt-4">
                    <div class="col-12 col-lg-8">
                        <div class="row px-2 px-md-4 px-lg-5">
                            <div class="col-4 col-md-4 col-lg-3 text-right">
                                <img src="../assets/kovatek/dev.png" alt="" class="rounded-circle img-height" />
                            </div>
                            <div class="col-6 col-md-6 ml-0 px-0">
                                <h3 class="text-left font-weight-bolder kova-text ctrl-heading">
                                Johnson. K <img class="ml-1 ml-md-2 mb-1" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" /> <font-awesome-icon icon="user-check" class="user-check-col ml-2"></font-awesome-icon>
                                </h3>
                                <h4 class="text-left mb-1 ctrl-heading1">Web Developer</h4>
                                <h6 class="text-uppercase text-left mb-1 text-intermediate ctrl-heading2">intermediate</h6>
                                <h4 class="text-left mb-1 ctrl-heading1">Jobs Completed: 4</h4>
                                <div class="text-left mt-3">
                                        <span class="text-size1 font-weight-bolder">$30</span>/hr
                                        <span class="text-size2 text-left"><font-awesome-icon style="font-size: 20px;" icon="map-marker-alt" class="text-dark ml-2 ml-md-3 mr-2"></font-awesome-icon>Lagos, Nigeria</span>
                                </div>
                            </div>
                            <div class="col-12 col-lg-2 text-right pr-3">
                                <!-- <div class="">
                                    <font-awesome-icon icon="pen" class="text-dark ml-3 mr-2 pen-icon"></font-awesome-icon>
                                </div>
                                <p class="text-size2 font-italic pr-2">Update</p> -->
                                <div class="mt-lg-5 pt-4 pb-3 text-center">
                                    <span class="btn-kovatek py-2 px-4 invite shadow-sm pointer" style="font-size: 18px;white-space:nowrap;" @click="showModal">Invite for Project</span>
                                    <div class="d-flex justify-content-center mt-2 ml-4 ml-lg-5 mt-3">
                                        <h4 class="ctrl-heading1"> Save Profile</h4> <font-awesome-icon style="font-size:24px" class="icon-size mr-3 ml-3 kova-light" :icon="['far', 'bookmark']" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <div class="reviews mr-5 mt-lg-5">
                            <span class=""><img class="mr-3 mr-md-4 star" src="../assets/kovatek/best.svg" alt="" /><span class="font-weight-bolder text-size rating">9.5</span><span class="ml-2 ctrl-size-2">56 reviews</span></span>
                            <!-- <div class="mt-lg-4">
                                <button class="programming-task px-4 px-md-5 py-2 text-size2">Programming Task</button>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="px-3 mx-md-4 mx-lg-5 mt-5">
                    <div class="row">
                        <div class="col-12 col-lg-8">
                            <div class="row mb-4">
                                <div class="col-3">
                                    <h4 class="font-weight-bolder text-left">Skill Score</h4>
                                </div>
                                <div class="col"></div>
                                <div class="col-3">
                                    <h4 class="font-weight-bolder text-right kova-text">65%</h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <h6 class="font-weight-bolder text-left kova-text">Profile</h6>
                                </div>
                                <div class="col"></div>
                                <div class="col-3">
                                    <h6 class="font-weight-bolder text-right kova-text">19/25</h6>
                                </div>
                            </div>
                            <div class="row" :key="profile" v-for="profile in profileScore">
                                <div class="col-8">
                                    <p class="text-left text-size3">- {{profile.title}}</p>
                                </div>
                                <div class="col"></div>
                                <div class="col-2 d-flex justify-content-end">
                                   <div class="score">{{profile.score}}</div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-6">
                                    <h6 class="font-weight-bolder text-left kova-text">Sprint Project Exercise</h6>
                                </div>
                                <div class="col"></div>
                                <div class="col-3">
                                    <h6 class="font-weight-bolder text-right kova-text">22/25</h6>
                                </div>
                            </div>
                            <div class="row" :key="sprint" v-for="sprint in sprintScore">
                                <div class="col-5 col-sm-4 col-md-3">
                                    <p class="text-left text-size3">- {{sprint.title}}</p>
                                </div>
                                <div class="col">
                                    <a-progress :percent="sprint.progress" strokeColor="#4BB38E"/>
                                </div>
                                <div class="col-2 d-flex justify-content-end">
                                   <div class="score">{{sprint.score}}</div>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-6">
                                    <h6 class="font-weight-bolder text-left kova-text">Live Interview</h6>
                                </div>
                                <div class="col"></div>
                                <div class="col-3">
                                    <h6 class="font-weight-bolder text-right kova-text">24/50</h6>
                                </div>
                            </div>
                            <div class="row" :key="interview" v-for="interview in interviewScore">
                                <div class="col-8">
                                    <p class="text-left text-size3">- {{interview.title}}</p>
                                </div>
                                <div class="col"></div>
                                <div class="col-2 d-flex justify-content-end">
                                   <div class="score">{{interview.score}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-4">
                            <div class="ml-4 bg-light px-4 border add-rounded mt-5 mt-sm-5 mt-lg-0" style="position:sticky; top:70px">
                                <div class="mt-5">
                                    <h5 class="font-weight-bolder mb-0">Connect with Talent</h5>
                                    <div class="">
                                        <a-input class="mt-3 w-100" size="" placeholder="Work Email" ref="searchInput"></a-input> 
                                    </div>
                                    <div class="">
                                        <a-input class="mt-3 w-100" size="" type="password" placeholder="Password" ref="searchInput"></a-input> 
                                    </div>
                                    <div class="">
                                        <a-input class="mt-3 w-100" size="" type="password" placeholder="Confirm Password" ref="searchInput"></a-input> 
                                    </div>
                                    <button class="btn-kovatek px-3 px-md-4 px-lg-5 py-2 my-4 add-rounded">Sign Up</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <div class="">
            <a-modal v-model="visible" onOk="handleOk" width="750px" centered>
            <template slot="footer">
                <div class="d-flex">
                    <button key="back" @click="handleOk" class="btn-kovatek add-rounded px-5 py-2 mr-auto">Yes</button>
                    <button key="submit" @click="handleCancel" class="btn-outline-kovatek add-rounded px-5 py-2">No</button>
                </div>
                
            </template>
            <div class="d-flex font-weight-bolder flex-wrap">
                <span class="kova-text modal-text mt-md-4">Hire</span>
                <div class="row bg-light py-3 add-rounded modal-row-width mx-auto">
                    <div class="col-3 pl-1 text-right">
                        <img src="../assets/kovatek/Mask Group 46.svg" alt="" class="rounded-circle img-height-1 " />
                    </div>
                    <div class="col-9 text-left">
                        <h5 class="font-weight-bolder kova-text mb-0 modal-name">Adebayo Mary
                            <img class="ml-1 ml-md-2 mb-1" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                        </h5>
                        <p><span class="font-italic">Web Developer</span> <span class="ml-sm-3 text-uppercase intermediate">intermediate</span> </p>
                    </div>
                </div>
                <span class="kova-text modal-text mt-md-4">For You Project?</span>
            </div>
            </a-modal>
        </div>
        <div class="mt-5"></div>
        <Footer />
    </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import moment from 'moment';

export default {
    name: 'skill-score',
    components: {
        Navbar, 
        Footer
    },
    data(){
        return {
            profileScore: [
                {title:  'Project Completed with core teck stack', score: 4.0},
                {title:  'Years of experience with core tech stack', score: 4.5},
                {title:  'Number of Project Completed being a Team Lead', score: 4.0},
                {title:  'Years of Oce Work Experience', score: 3.5},
                {title:  'Number of Remote Work Completed', score: 5.0}

            ],
            sprintScore: [
                {title: 'Code Quality', progress: 70, score: 5.0},
                {title: 'Tools Using Ability', progress: 70, score: 5.0},
                {title: 'Algorithms', progress: 40, score: 3.0},
                {title: 'Debugging', progress: 60, score: 5.0},
                {title: 'Data Structure', progress: 50, score: 3.0},
                {title: 'Security', progress: 90, score: 6.0}
            ],
            interviewScore: [
                {title:  'Communication', score: 5},
                {title:  'Algorithm', score: 5},
                {title:  'Problem Solving', score: 9},
                {title:  'Professionalism', score: 11},
                {title:  'API', score: 4},
            ],
            date: Date.now(),
            interviewDate: Date.now(),
            time: Date.now(),
            loading: false,
            visible: false,
            callScheduled: false,
            interviewModal: false,
            interviewScheduled: false,
            sprintModal: false,
            sprintScheduled: false
        }
    },
    methods: {
        onSelect(value) {
        this.date = value;
        this.interviewDate = value;
      },
        onPanelChange(value) {
            // console.log(value, mode);
            this.date = value;
            this.interviewDate = value;

        },
        showModal() {
            this.visible = true;
        },
        handleOk() {
            this.loading = true;
            setTimeout(() => {
            this.visible = false;
            this.loading = false;
            }, 3000);
        },
        handleCancel() {
            this.visible = false;   
        },
        getTime(time) {
        // console.log(time, timeString);
            this.time = time;
        },
        showCallScheduled(){
            this.loading = true;
                setTimeout(() => {
                this.visible = false;
                this.loading = false;
                this.callScheduled = true;
                }, 3000);
        },
        callScheduledOk(){
            this.callScheduled = false;
        },
        showInterview() {
            this.interviewModal = true;
        },
        showInterviewScheduled() {
            this.loading = true;
                setTimeout(() => {
                this.interviewModal = false;
                this.loading = false;
                this.interviewScheduled = true;
                }, 3000);
        },
        interviewScheduledOk(){
            this.interviewScheduled = false;
        },
        interviewCancel() {
            this.interviewModal = false;   
        },
        showSprint() {
            this.sprintModal = true;
        },
        showSprintScheduled() {
            this.loading = true;
                setTimeout(() => {
                this.sprintModal = false;
                this.loading = false;
                this.sprintScheduled = true;
                }, 3000);
        },
        sprintScheduledOk(){
            this.sprintScheduled = false;
        },
        sprintCancel() {
            this.sprintModal = false;   
        }
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY, h:mm a');
        },
        dateOnly: function (date) {
            return moment(date).format('MMMM Do YYYY');
        },
        timeOnly : function (time) {
            return moment(time).format('h:mm a')
        }
    }

}
</script>

<style scoped>
.bg-kovatek{
    background-color: #20409a
}
.img-height{
    width: 160px;
    height: 160px;
}
.img-height-1{
    width: 70px;
    height: 70px;
}
.text-intermediate{
    color: #BDBD50;
}
.text-size{
    font-size: 2.5em;
}
.text-size1{
    font-size: 20px;
}
.text-size2{
    font-size: 18px;
}
.text-size3{
    font-size: 13px;
}
.rating{
    color:#4BB38E;
}
.invite{ 
    width: 180px;
    border-radius: 20px;
}   
.star{
    position: relative;
    bottom: 10px;
    height: 25px;
}
.programming-task{
    background-color: transparent;
    outline: 0;
    border: solid 2px #20409a;
    border-radius: 20px;
    color: #20409a;
    transition: .25s;
}
.programming-task:hover{
    background-color: #20409a;
    color: #fff;
}
.pen-icon{
    font-size: 22px;
}
.score{
    width: 25px;
    height: 20px;
    background-color: #4BB38E;
    border-radius: 5px;
    color: #fff;
}
.request{
    border-radius: 20px;
}
.messaging{
  background-color: #f1f1f1;
  color: #4f5052;
  transition: .25s;
  border: solid 1px #f1f1f1;
  outline: 0;
}
.messaging:hover{
  background-color: #d3d3d3;
  color: #4f5052;
}
.point{
    width: 20px;
    height: 20px;
    background-color: #20409a;
    border-radius: 50%;
}
.modal-row-width{
    width: 350px
}
.modal-text{
    font-size: 30px;
}
@media screen and (min-width: 992px) and (max-width: 1325px){
    
}

@media screen and (min-width: 992px) and (max-width: 1200px){
    .img-height{
        width: 120px;
        height: 120px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px){
   .img-height{
        width: 120px;
        height: 120px;
    }
}

@media screen and (max-width: 767px){
    .img-height{
        width: 115px;
        height: 115px;
    }
    .text-size{
        font-size: 1.8em;
    }
    .text-size2{
        font-size: 16px;
    }
    .ctrl-heading{
        font-size: 1.4em;
    }
    .ctrl-heading1{
        font-size: 1.2em;
    }
    .ctrl-heading2{
        font-size: 0.9em;
    }
    .star{
        position: relative;
        bottom: 5px;
        height: 18px;
    }
}

@media screen and (max-width: 550px){
    .text-size2{
        font-size: 12px;
    }
    .img-height{
        width: 85px;
        height: 85px;
    }
    .pen-icon{
        font-size: 12px;
    }
    .note-text{
        font-size: 15px;
    }
    .modal-name{
        font-size: 16px;
    }
    .img-height-1{
        width: 65px;
        height: 65px;
    }
}
</style>